const BLOG_SLUG_OVERRIDES = {
	"live-in-c": "live-in-care-in-the-north-west",
	"live-in-care-i": "live-in-care-in-the-west-midlands",
};

const LEGACY_ROUTE_REDIRECTS = {
	"/cta/": "/liveincare/looking-for-care/",
	"/blog/a-guide-to-state-funded-care/": "/blog/self-funding-care-your-options-explained/",
	"/blog/attendance-allowance/": "/blog/self-funding-care-your-options-explained/",
	"/blog/balancing-life-caring-for-ageing-parent/": "/blog/balancing-your-own-life-while-caring-for-an-ageing-parent/",
	"/blog/can-a-live-in-carer-drive/": "/blog/can-a-live-in-carer-drive-my-loved-one/",
	"/blog/care-company-vs-matching-agency/": "/blog/live-in-care-company-vs-matching-agency-whats-the-difference/",
	"/blog/carer-who-speaks-your-language/": "/blog/can-i-have-a-carer-who-speaks-my-loved-ones-language/",
	"/blog/companionship-as-care-loneliness/": "/blog/companionship-as-care-why-loneliness-is-a-health-issue-too/",
	"/blog/cqc-vs-introductory-agency/": "/blog/live-in-care-company-vs-matching-agency-whats-the-difference/",
	"/blog/end-of-life-care/": "/liveincare/",
	"/blog/essential-documents-before-care-starts/": "/blog/the-essential-documents-to-gather-before-care-starts/",
	"/blog/first-week-of-live-in-care/": "/blog/what-happens-in-the-first-week-of-live-in-care/",
	"/blog/how-carers-handle-medication/": "/blog/how-do-our-carers-handle-medication-safely/",
	"/blog/how-to-decide-on-the-right-carer-for-you/": "/blog/how-to-find-the-right-carer-for-you/",
	"/blog/keeping-routines-and-rituals-alive/": "/blog/keeping-a-parents-routines-and-rituals-alive/",
	"/blog/live-in-care-starter-checklist/": "/blog/the-live-in-care-starter-checklist-what-to-have-ready-before-day-one/",
	"/blog/live-in-care-vs-care-home/": "/blog/live-in-care-vs-care-home-which-option-is-right/",
	"/blog/local-authority-funding/": "/blog/self-funding-care-your-options-explained/",
	"/blog/long-distance-caregiving/": "/blog/long-distance-caregiving-staying-involved-when-you-live-far-away/",
	"/blog/minimum-cover-time-for-live-in-care/": "/blog/what-is-the-minimum-cover-time-for-live-in-care/",
	"/blog/moving-and-handling-live-in-care/": "/blog/moving-and-handling-how-our-carers-keep-your-loved-one-safe-and-mobile/",
	"/blog/multi-generational-multicultural-households/": "/blog/live-in-care-for-multi-generational-and-multicultural-households/",
	"/blog/nhs-prescription-costs-older-people/": "/blog/nhs-prescription-costs-and-free-prescriptions-for-older-people/",
	"/blog/our-covid-19-response/": "/blog/",
	"/blog/parent-doesnt-want-a-stranger-in-the-house/": "/blog/when-your-parent-doesnt-want-a-stranger-in-the-house/",
	"/blog/pets-and-live-in-care/": "/blog/pets-and-live-in-care-keeping-the-whole-household-comfortable/",
	"/blog/rehabilitation-care-at-home/": "/blog/rehabilitation-care-at-home-support-for-recovery-after-hospital/",
	"/blog/self-funding-care/": "/blog/self-funding-care-your-options-explained/",
	"/blog/setting-up-a-home-pharmacy/": "/blog/setting-up-a-home-pharmacy-medication-storage-and-organisation/",
	"/blog/state-and-local-authority-funding/": "/blog/self-funding-care-your-options-explained/",
	"/blog/what-are-my-funding-options-for-care/": "/blog/self-funding-care-your-options-explained/",
	"/blog/what-are-my-funding-options/": "/blog/self-funding-care-your-options-explained/",
	"/blog/what-can-a-live-in-carer-help-with/": "/blog/what-can-a-live-in-carer-help-with-2/",
	"/blog/what-happens-if-your-loved-one-goes-into-hospital/": "/blog/what-happens-when-your-loved-one-goes-into-hospital/",
	"/blog/what-happens-when-discharged-from-hospital/": "/blog/what-happens-when-your-loved-one-is-discharged-from-hospital-or-a-care-home/",
	"/blog/what-is-a-care-assessment/": "/blog/what-is-a-care-assessment-2/",
	"/blog/what-is-a-care-consultation/": "/care-consultation/",
	"/blog/what-is-the-cost-of-live-in-care/": "/blog/what-is-the-cost-of-live-in-care-2/",
	"/blog/when-both-parents-need-care/": "/blog/when-both-parents-need-care-at-the-same-time/",
	"/blog/when-is-care-needed/": "/blog/when-is-care-needed-how-to-spot-the-signs-and-what-to-do-next/",
};

Object.entries(BLOG_SLUG_OVERRIDES).forEach(([oldSlug, newSlug]) => {
	LEGACY_ROUTE_REDIRECTS[`/blog/${oldSlug}/`] = `/blog/${newSlug}/`;
});

function getPublicBlogSlug(slug) {
	return BLOG_SLUG_OVERRIDES[slug] || slug;
}

function getBlogPath(slug) {
	return `/blog/${getPublicBlogSlug(slug)}/`;
}

function getCanonicalInternalPath(value) {
	if (!value) return value;

	let url;
	try {
		url = new URL(value, "https://www.edyn.care");
	} catch (_) {
		return value;
	}

	if (!["edyn.care", "www.edyn.care"].includes(url.hostname)) return value;

	const replacement = LEGACY_ROUTE_REDIRECTS[url.pathname];
	return replacement ? `${replacement}${url.search}${url.hash}` : value;
}

function rewriteLegacyBlogLinks(html) {
	if (!html) return html;

	return html.replace(/href=(['"])([^'"]+)\1/gi, (match, quote, href) => {
		return `href=${quote}${getCanonicalInternalPath(href)}${quote}`;
	});
}

module.exports = {
	BLOG_SLUG_OVERRIDES,
	LEGACY_ROUTE_REDIRECTS,
	getBlogPath,
	getCanonicalInternalPath,
	getPublicBlogSlug,
	rewriteLegacyBlogLinks,
};
